module.exports = __webpack_public_path__ + "img/7df738a.jpg";